import { filter, includes, join, map } from 'lodash'

type Participant = {
  userId: string
  userFirstName: string
  userLastName: string
  deactivated?: boolean
}

type Room = {
  userIds: string[]
}

export function renderRoomTitle(room: Room | null, participants: Participant[], userId: string, isAdmin: boolean) {
  if (!room) return ''

  if (room.userIds.includes('admin') && !isAdmin) {
    console.log('IS NOT ADMIN')
    return 'Admin'
  }

  let inRoom = filter(participants, participant => {
    if (participant.userId === userId) return false
    if (participant.userId === 'admin') return false
    return includes(room.userIds, participant.userId)
  })

  let firstNames = map(inRoom, user => {
    if (user.deactivated) return `${user.userFirstName} (deactivated)`
    return `${user.userFirstName} ${user.userLastName[0]}`
  })

  return join(firstNames, ', ')
}
